import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const AuthContext = createContext(undefined);

function getStoredToken() {
  try {
    return localStorage.getItem("agent_token");
  } catch (error) {
    console.warn("No se pudo recuperar el token almacenado", error);
    return null;
  }
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    const token = getStoredToken();
    if (!token) {
      setStatus("ready");
      return;
    }

    const source = axios.CancelToken.source();

    async function bootstrap() {
      try {
        setStatus("loading");
        const { data } = await axios.get("/auth/me", {
          cancelToken: source.token,
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setUser(data.user);
      } catch (error) {
        localStorage.removeItem("agent_token");
        console.error("Sesión inválida", error.message);
      } finally {
        setStatus("ready");
      }
    }

    bootstrap();
    return () => source.cancel();
  }, []);

  const value = useMemo(
    () => ({
      user,
      status,
      setUser
    }),
    [user, status]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth debe usarse dentro de AuthProvider");
  }
  return ctx;
};
